import React, { useEffect, useState } from "react";
import {
  Button,
  Divider,
  Modal,
  Select,
  Skeleton,
  Text,
  TextInput,
} from "@mantine/core";
import { Search } from "tabler-icons-react";
import flat from "flat";
import { showNotification } from "@mantine/notifications";
import { BeatLoader } from "react-spinners";
import colors from "../../utilities/design";
import AgreementListModal from "./AgreementListModal";
import { DatePicker } from "@mantine/dates";
import { getBussinessUnit } from "../../utilities/apis/serviceProvider";
import { differenceInMonths, differenceInYears, differenceInDays, addYears, addMonths, addDays, parseISO, subDays, formatISO } from "date-fns";
import { loadingStates } from "../../utilities/utilities";
import { getBuList } from "../../utilities/apis/users";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";

export const INDIA_STATES_UNIONS = [
  { label: "Andhra Pradesh", value: "Andhra Pradesh" },
  { label: "Karnataka", value: "Karnataka" },
  {
    label: "Andaman and Nicobar Islands",
    value: "Andaman and Nicobar Islands",
  },
  { label: "Arunachal Pradesh", value: "Arunachal Pradesh" },
  { label: "Assam", value: "Assam" },
  { label: "Bihar", value: "Bihar" },
  { label: "Chandigarh", value: "Chandigarh" },
  { label: "Chattisgarh", value: "Chattisgarh" },
  { label: "Dadra and Nagar Haveli", value: "Dadra and Nagar Haveli" },
  { label: "Daman and Diu", value: "Daman and Diu" },
  { label: "Delhi", value: "Delhi" },
  { label: "Goa", value: "Goa" },
  { label: "Gujarat", value: "Gujarat" },
  { label: "Haryana", value: "Haryana" },
  { label: "Himachal Pradesh", value: "Himachal Pradesh" },
  { label: "Jammu and Kashmir", value: "Jammu and Kashmir" },
  { label: "Jharkhand", value: "Jharkhand" },
  { label: "Kerala", value: "Kerala" },
  { label: "Lakshadweep Islands", value: "Lakshadweep Islands" },
  { label: "Madhya Pradesh", value: "Madhya Pradesh" },
  { label: "Maharashtra", value: "Maharashtra" },
  { label: "Manipur", value: "Manipur" },
  { label: "Meghalaya", value: "Meghalaya" },
  { label: "Mizoram", value: "Mizoram" },
  { label: "Nagaland", value: "Nagaland" },
  { label: "Odisha", value: "Odisha" },
  { label: "Pondicherry", value: "Pondicherry" },
  { label: "Punjab", value: "Punjab" },
  { label: "Rajasthan", value: "Rajasthan" },
  { label: "Sikkim", value: "Sikkim" },
  { label: "Tamil Nadu", value: "Tamil Nadu" },
  { label: "Telangana", value: "Telangana" },
  { label: "Tripura", value: "Tripura" },
  { label: "Uttar Pradesh", value: "Uttar Pradesh" },
  { label: "Uttarakhand", value: "Uttarakhand" },
  { label: "West Bengal", value: "West Bengal" },
];

const LegacyAgreementForm1 = ({
  setLegacyAgreementFormValue,
  legacyAgreementFormValue,
  uiConfigs,
  setUiConfigs,
  saveAgreement,
}) => {
  const typeOfDocuments = [
    "Parent",
    "Supplementary",
    "Supplementary to Supplementary",
  ];
  const [errors, setErrors] = useState({});
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLegacyAgreementFormValue({
      ...legacyAgreementFormValue,
      requestingUser: {
        ...legacyAgreementFormValue.requestingUser,
        [name]: value,
      },
    });
  };

  const [businessUnitsOptions, setBusinessUnitsOptions] = useState([]);

  useEffect(() => {
    const fetchBusinessUnits = async () => {
      try {
        const response = await apiWrapWithErrorWithData(getBuList());
        console.log("response: ", response);
        if (response.success) {
          const formattedData = response.result.map(({ id, name }) => ({
            value: id.toString(),
            label: name,
          }));
          setBusinessUnitsOptions(formattedData);
        }
      } catch (error) {
        console.error("Error fetching business units:", error);
      }
    };
    fetchBusinessUnits();
  }, []);
  const reminderLabels = {
    15: "15 days",
    30: "30 days",
    45: "45 days",
    60: "60 days",
  };
  // const saveNext = async () => {
  //   const keys = {};
  //   if (
  //     !legacyAgreementFormValue?.relationshipType ||
  //     legacyAgreementFormValue?.relationshipType?.length < 3
  //   ) {
  //     keys.relationshipType = "Type of agreement is mandatory.";
  //   }
  //   if (legacyAgreementFormValue.relationshipType === "Supplementary" ||
  //               legacyAgreementFormValue.relationshipType ===
  //                 "Supplementary to Supplementary") {
  //     if (!legacyAgreementFormValue.relationshipWith) {
  //       keys.relationshipWith = "fill connected agreement";
  //     }
  //   }
  //   if (
  //     !legacyAgreementFormValue?.typeOfAgreement ||
  //     legacyAgreementFormValue?.typeOfAgreement?.length < 3
  //   ) {
  //     keys.typeOfAgreement = "Type is mandatory.";
  //   }
  //   if (
  //     !legacyAgreementFormValue?.titleOfAgreement ||
  //     legacyAgreementFormValue?.titleOfAgreement?.length < 3
  //   ) {
  //     keys.titleOfAgreement = "Title is mandatory.";
  //   }
  //   if (
  //     !legacyAgreementFormValue?.titleOfAgreement ||
  //     legacyAgreementFormValue?.titleOfAgreement?.length > 50
  //   ) {
  //     keys.titleOfAgreement =
  //       "The title for the agreement should stay within 50 characters or less.";
  //   }
  //   if (
  //     !legacyAgreementFormValue.dateOfContract ||
  //     isNaN(parseISO(legacyAgreementFormValue.dateOfContract).getTime())
  //   ) {
  //     keys["dateOfContract"] = "Please enter date.";
  //   }

  //   if (!legacyAgreementFormValue.businessUnit) {
  //     keys["businessUnit"] = "Please enter Business Unit.";
  //   }

  //   if (
  //     (!legacyAgreementFormValue.noOfYears ||
  //       isNaN(legacyAgreementFormValue.noOfYears) ||
  //       parseInt(legacyAgreementFormValue.noOfYears, 10) <= 0) &&
  //     (!legacyAgreementFormValue.noOfMonths ||
  //       isNaN(legacyAgreementFormValue.noOfMonths) ||
  //       parseInt(legacyAgreementFormValue.noOfMonths, 10) <= 0)
  //   ) {
  //     keys["noOfYears"] = "Please check value.";
  //     keys["noOfMonths"] = "Please check value.";
  //   }
  //   // if (legacyAgreementFormValue?.requestingUser?.phone?.length > 0) {
  //   //   if (
  //   //     !validateMobile(legacyAgreementFormValue?.requestingUser?.phone) ||
  //   //     legacyAgreementFormValue?.requestingUser?.phone.length !== 10
  //   //   ) {
  //   //     keys["requestingUser.phone"] = "Please enter 10 digits phone number.";
  //   //   }
  //   // } else {
  //   //   keys["requestingUser.phone"] = "Please enter 10 digits phone number.";
  //   // }
  //   console.log("Validation errors:", keys);
  //   if (Object.keys(keys).length > 0) {
  //     setErrors(keys);
  //     showNotification({
  //       color: "red",
  //       title: "Agreement Form",
  //       message: "Please check all fields are filled properly.",
  //     });
  //   } else {
  //     await saveAgreement();
  //     setUiConfigs({
  //       ...uiConfigs,
  //       currentStep: 1,
  //     });
  //   }
  // };

  // Improved saveNext function with detailed validation
  const saveNext = async () => {
    // 1. Initialize a clean error object
    const keys = {};

    // 2. Extract values for easier reading
    const {
      relationshipType,
      relationshipWith,
      typeOfAgreement,
      titleOfAgreement,
      dateOfContract,
      businessUnit,
      noOfYears,
      noOfMonths,
    } = legacyAgreementFormValue;

    // 3. Document Type Validation
    if (!relationshipType || relationshipType.trim().length < 3) {
      keys.relationshipType = "Type of document is mandatory.";
    }

    // 4. Connected Agreement Validation
    const isSupplementary =
      relationshipType === "Supplementary" ||
      relationshipType === "Supplementary to Supplementary";

    if (isSupplementary) {
      // Check if it's null, undefined, or an empty string after trimming
      if (!relationshipWith || relationshipWith.toString().trim() === "") {
        keys.relationshipWith =
          "Connected agreement number is required for supplementary documents.";
      }
    }

    // 5. Category and Title Validation
    if (!typeOfAgreement || typeOfAgreement.trim().length < 3) {
      keys.typeOfAgreement = "agreement category is mandatory.";
    }

    if (!titleOfAgreement || titleOfAgreement.trim().length < 3) {
      keys.titleOfAgreement = "title is mandatory.";
    } else if (titleOfAgreement.length > 50) {
      keys.titleOfAgreement = "the title must be 50 characters or less.";
    }

    // 6. Date Validation
    if (!dateOfContract || isNaN(parseISO(dateOfContract).getTime())) {
      keys.dateOfContract = "please enter a valid starting date.";
    }

    // 7. Business Unit Validation
    if (!businessUnit) {
      keys.businessUnit = "please select a Business Unit.";
    }

    // 8. Duration Validation (Ensure at least years or months is > 0)
    // const years = parseInt(noOfYears, 10) || 0;
    // const months = parseInt(noOfMonths, 10) || 0;

    // if (years <= 0 && months <= 0) {
    //   keys.noOfYears = "duration required.";
    //   keys.noOfMonths = "Check months.";
    // }
    const years = parseInt(legacyAgreementFormValue.noOfYears, 10) || 0;
    const months = parseInt(legacyAgreementFormValue.noOfMonths, 10) || 0;
    const days = parseInt(legacyAgreementFormValue.noOfDays, 10) || 0;

    const hasDuration = years > 0 || months > 0 || days > 0;
    const hasEndDate = Boolean(legacyAgreementFormValue.dueDateOfContract);

    // Either duration OR end date is mandatory
    if (!hasDuration && !hasEndDate) {
      keys.noOfYears = "duration or end date is required.";
      keys.dueDateOfContract = "duration or end date is required.";
    }

    // End date must be > starting date
    if (
      hasEndDate &&
      legacyAgreementFormValue.dateOfContract &&
      parseISO(legacyAgreementFormValue.dueDateOfContract) <=
        parseISO(legacyAgreementFormValue.dateOfContract)
    ) {
      keys.dueDateOfContract = "end date must be after the starting date.";
    }


    // 9. Execute based on error count
    console.log("Validation Results:", keys);

    if (Object.keys(keys).length > 0) {
      setErrors(keys);
      showNotification({
        color: "red",
        title: "agreement form",
        message: "please check all fields are filled properly.",
      });
    } else {
      setErrors({}); // Clear errors on success
      await saveAgreement();
      setUiConfigs({
        ...uiConfigs,
        currentStep: 1,
      });
    }
  };

  const [showModal, setShowModal] = useState(false);
  const [selectedAgreement, setSelectedAgreement] = useState(0);
  const handleSearchClick = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    if (selectedAgreement) {
      setLegacyAgreementFormValue({
        ...legacyAgreementFormValue,
        relationshipWith: selectedAgreement + "",
      });
    }
  }, [selectedAgreement]);

  console.log("agreementFormValues", legacyAgreementFormValue);

  const hasDuration =
    Number(legacyAgreementFormValue.noOfYears || 0) > 0 ||
    Number(legacyAgreementFormValue.noOfMonths || 0) > 0 ||
    Number(legacyAgreementFormValue.noOfDays || 0) > 0;

  const hasEndDate = Boolean(legacyAgreementFormValue.dueDateOfContract);

  const resetDuration = () => {
    setLegacyAgreementFormValue({
      ...legacyAgreementFormValue,
      noOfYears: "0",
      noOfMonths: "0",
      noOfDays: "0",
      durationTouched: false,
    });
  };

  const calculateDurationFromDates = (startISO, endISO) => {
    const start = parseISO(startISO);
    const end = parseISO(endISO);

    if (end <= start) {
      return { years: "0", months: "0", days: "0" };
    }

    const years = differenceInYears(end, start);
    const afterYears = addYears(start, years);

    const months = differenceInMonths(end, afterYears);
    const afterMonths = addMonths(afterYears, months);

    const days = differenceInDays(end, afterMonths);

    return {
      years: years.toString(),
      months: months.toString(),
      days: days.toString(),
    };
  };

  return (
    <>
      {showModal && (
        <Modal
          overflow="inside"
          opened
          onClose={handleCloseModal} // Call the handler on modal close
          size="calc(80vw)"
        >
          <AgreementListModal
            onCloseAgreement={handleCloseModal}
            setSelectedAgreement={setSelectedAgreement}
          />
        </Modal>
      )}
      <div className="w-full flex flex-col my-4">
        <div className="grid grid-cols-2">
          <div>
            <Select
              required
              className="max-w-lg"
              label="contract type"
              placeholder="contract type"
              data={typeOfDocuments.map((value) => ({ value, label: value }))}
              onChange={(selectedOption) => {
                setLegacyAgreementFormValue({
                  ...legacyAgreementFormValue,
                  relationshipType: selectedOption,
                });
              }}
              value={legacyAgreementFormValue.relationshipType}
              style={{ maxWidth: "82%" }}
              error={errors.relationshipType && errors.relationshipType}
            />
          </div>
          <div style={{ maxWidth: "82%" }} className="flex">
            <TextInput
              label="connected contract"
              placeholder="enter contract number"
              required={
                legacyAgreementFormValue.relationshipType === "Supplementary" ||
                legacyAgreementFormValue.relationshipType ===
                  "Supplementary to Supplementary"
              }
              onChange={(e) => {
                setLegacyAgreementFormValue({
                  ...legacyAgreementFormValue,
                  relationshipWith: e.target.value,
                });
              }}
              value={legacyAgreementFormValue.relationshipWith}
              type="number"
              style={{
                width: "88%",
                display: "inline-block",
                marginRight: "2%",
              }}
              error={errors.relationshipWith && errors.relationshipWith}
            />
            <Button
              className="max-w-lg"
              // color="#64748B"
              onClick={handleSearchClick} // Call the handler on button click
              style={{
                width: "10%",
                display: "inline-block",
                marginBottom: "0",
                marginTop: "auto",
                padding: "0",
                // backgroundColor: "#46BDE1",
              }}
            >
              <Search size={20} strokeWidth={3} />
            </Button>
          </div>
        </div>
        <div className="grid grid-cols-2 mt-4">
          <Select
            searchable
            required
            creatable
            className="max-w-lg"
            style={{ maxWidth: "82%" }}
            label="contract category"
            placeholder="select contract category"
            data={legacyAgreementFormValue.typeOfAgreementData}
            getCreateLabel={(query) => `+ add ${query}`}
            onCreate={(query) => {
              setLegacyAgreementFormValue({
                ...legacyAgreementFormValue,
                typeOfAgreementData: [
                  ...legacyAgreementFormValue.typeOfAgreementData,
                  query,
                ],
              });
            }}
            onChange={(selectedOption) => {
              setLegacyAgreementFormValue({
                ...legacyAgreementFormValue,
                typeOfAgreement: selectedOption,
              });
            }}
            value={legacyAgreementFormValue.typeOfAgreement}
            error={errors.typeOfAgreement && errors.typeOfAgreement}
          />
          <Select
            searchable
            required
            creatable
            className="max-w-lg"
            label="contract title"
            placeholder="select contract title"
            style={{ maxWidth: "82%" }}
            data={legacyAgreementFormValue.titleOfAgreementData}
            getCreateLabel={(query) => `+ add ${query}`}
            onCreate={(query) => {
              setLegacyAgreementFormValue({
                ...legacyAgreementFormValue,
                titleOfAgreementData: [
                  ...legacyAgreementFormValue.titleOfAgreementData,
                  query,
                ],
              });
            }}
            onChange={(selectedOption) => {
              setLegacyAgreementFormValue({
                ...legacyAgreementFormValue,
                titleOfAgreement: selectedOption,
              });
            }}
            value={legacyAgreementFormValue.titleOfAgreement}
            error={errors.titleOfAgreement}
          />
        </div>

        <div className="grid grid-cols-2 mt-4">
          <TextInput
            label="job order"
            placeholder="enter job order"
            value={legacyAgreementFormValue.jobOrder}
            onChange={(e) => {
              setLegacyAgreementFormValue({
                ...legacyAgreementFormValue,
                jobOrder: e.target.value,
              });
            }}
            error={errors.jobOrder && errors.jobOrder}
            style={{ maxWidth: "82%" }}
          />
        </div>
        <Divider className="mt-8" />
        <Text size="md" color="#1b6f8d" className="my-4">
          term & location
        </Text>
        <div className="grid grid-cols-2 mt-2 mb-2">
          <DatePicker
            required
            style={{ maxWidth: "82%" }}
            label="starting date"
            placeholder="select starting date"
            onChange={(val) => {
              if (val && val.getTime) {
                setLegacyAgreementFormValue({
                  ...legacyAgreementFormValue,
                  dateOfContract: formatISO(val),
                });
              } else {
                setLegacyAgreementFormValue({
                  ...legacyAgreementFormValue,
                  dateOfContract: null,
                });
              }
            }}
            value={
              legacyAgreementFormValue.dateOfContract
                ? parseISO(legacyAgreementFormValue.dateOfContract)
                : null
            }
            error={errors.dateOfContract && errors.dateOfContract}
          />

          <div
            className="flex flex-row"
            style={{ marginBottom: "20px", maxWidth: "82%" }}
          >
            {/* <Select
              required
              label="duration"
              placeholder="select years"
              data={[
                ...Array.from({ length: 11 }, (_, i) => ({
                  value: `${i}`,
                  label: `${i} year${i === 1 ? "" : "s"}`,
                })),
                { value: "100", label: "100 years" }, // Add the option for 100 years
              ]}
              onChange={(selectedOption) => {
                setLegacyAgreementFormValue({
                  ...legacyAgreementFormValue,
                  noOfYears: selectedOption,
                });
              }}
              value={legacyAgreementFormValue.noOfYears}
              style={{ width: "160px", marginRight: "20px" }}
              error={errors.noOfYears && errors.noOfYears}
            />
            <Select
              label="   "
              placeholder="select months"
              data={[
                { value: "0", label: "0 month" },
                ...Array.from({ length: 12 }, (_, i) => ({
                  value: `${i + 1}`,
                  label: `${i + 1} month${i === 0 || i === 1 ? "" : "s"}`,
                })),
              ]}
              onChange={(selectedOption) => {
                setLegacyAgreementFormValue({
                  ...legacyAgreementFormValue,
                  noOfMonths: selectedOption,
                });
              }}
              value={legacyAgreementFormValue.noOfMonths}
              style={{ width: "160px" }}
              error={errors.noOfMonths && errors.noOfMonths}
            /> */}
          </div>
          {/* DURATION (shown only if end date is NOT selected) */}
          {!hasEndDate && (
            <div
              className="flex items-end gap-3 mb-3"
              style={{ maxWidth: "82%" }}
            >
              {/* YEARS */}
              <Select
                label="duration"
                placeholder="years"
                data={[
                  ...Array.from({ length: 11 }, (_, i) => ({
                    value: `${i}`,
                    label: `${i} year${i === 1 ? "" : "s"}`,
                  })),
                  { value: "100", label: "100 years" },
                ]}
                value={legacyAgreementFormValue.noOfYears}
                onChange={(val) => {
                  setLegacyAgreementFormValue({
                    ...legacyAgreementFormValue,
                    noOfYears: val,
                    dueDateOfContract: null, //hide end date
                  });
                }}
                style={{ width: "140px", marginRight: "12px" }}
              />

              {/* MONTHS */}
              <Select
                placeholder="months"
                data={[
                  { value: "0", label: "0 month" },
                  ...Array.from({ length: 12 }, (_, i) => ({
                    value: `${i + 1}`,
                    label: `${i + 1} month${i === 1 ? "" : "s"}`,
                  })),
                ]}
                value={legacyAgreementFormValue.noOfMonths}
                onChange={(val) => {
                  setLegacyAgreementFormValue({
                    ...legacyAgreementFormValue,
                    noOfMonths: val,
                    dueDateOfContract: null,
                  });
                }}
                style={{ width: "140px", marginRight: "12px" }}
              />

              {/* DAYS  */}
              <Select
                placeholder="days"
                data={[
                  { value: "0", label: "0 day" },
                  ...Array.from({ length: 30 }, (_, i) => ({
                    value: `${i + 1}`,
                    label: `${i + 1} day${i === 1 ? "" : "s"}`,
                  })),
                ]}
                value={legacyAgreementFormValue.noOfDays}
                onChange={(val) => {
                  setLegacyAgreementFormValue({
                    ...legacyAgreementFormValue,
                    noOfDays: val,
                    dueDateOfContract: null,
                  });
                }}
                style={{ width: "140px" }}
              />

              <Button
                variant="subtle"
                color="gray"
                mt={22}
                onClick={resetDuration}
              >
                ✕
              </Button>
            </div>
          )}

          {/* END DATE (only if duration is NOT selected) */}
          {!hasDuration && (
            <div
              className="mb-3"
              style={{ maxWidth: "82%" }}
            >
              <DatePicker
                label="end date"
                placeholder="select end date"
                onChange={(val) => {
                  if (
                    val &&
                    val.getTime &&
                    legacyAgreementFormValue.dateOfContract
                  ) {
                    const endISO = formatISO(val);

                    const { years, months } = calculateDurationFromDates(
                      legacyAgreementFormValue.dateOfContract,
                      endISO,
                    );

                    setLegacyAgreementFormValue({
                      ...legacyAgreementFormValue,
                      dueDateOfContract: endISO,
                      noOfYears: "0",
                      noOfMonths: "0",
                      noOfDays: "0",
                    });
                  } else {
                    setLegacyAgreementFormValue({
                      ...legacyAgreementFormValue,
                      dueDateOfContract: null,
                      noOfYears: "0",
                      noOfMonths: "0",
                      noOfDays: "0",
                    });
                  }
                }}
                value={
                  legacyAgreementFormValue.dueDateOfContract
                    ? parseISO(legacyAgreementFormValue.dueDateOfContract)
                    : null
                }
                error={errors.dueDateOfContract}
              />
            </div>
          )}

          <Select
            style={{ marginBottom: "20px", maxWidth: "82%" }}
            placeholder="reminder time"
            label="renewal reminder time (in days)"
            data={[
              { value: 15, label: reminderLabels["15"] },
              { value: 30, label: reminderLabels["30"] },
              { value: 45, label: reminderLabels["45"] },
              { value: 60, label: reminderLabels["60"] },
            ]}
            onChange={(val) => {
              setLegacyAgreementFormValue({
                ...legacyAgreementFormValue,
                reminderTimeInDays: val,
              });
            }}
            value={legacyAgreementFormValue.reminderTimeInDays}
          />
          {/* <Select
            style={{ marginBottom: "20px", maxWidth: "82%" }}
            searchable
            placeholder="enter location"
            label="location"
            data={[...INDIA_STATES_UNIONS]}
            onChange={(val) => {
              setLegacyAgreementFormValue({
                ...legacyAgreementFormValue,
                location: val,
              });
            }}
            value={legacyAgreementFormValue.location}
          /> */}
          <Select
            required
            searchable
            placeholder="enter business unit"
            label="business unit"
            data={businessUnitsOptions}
            onChange={(val) => {
              setLegacyAgreementFormValue({
                ...legacyAgreementFormValue,
                businessUnit: val,
              });
            }}
            value={legacyAgreementFormValue.businessUnit}
            dropdownPosition="bottom"
            style={{ maxWidth: "82%" }}
            error={errors.businessUnit && errors.businessUnit}
          />
          {/* <TextInput required label="Location" placeholder='Enter location' {...legacyAgreementFormValue.getInputProps('location')}/> */}
        </div>
      </div>
      <div className="flex flex-row justify-between">
        <div></div>
        <Button
          className="max-w-xs right mt-20"
          // style={{
          //   backgroundColor: "#46BDE1",
          // }}
          variant="contained"
          onClick={saveNext}
        >
          next
        </Button>
      </div>
    </>
  );
};

export default LegacyAgreementForm1;
